import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

function ErrorFallback({ error }) {
  return (
    <div role='alert'>
      <p>Something went wrong:</p>
      <pre style={{ color: 'red' }}>{error.message}</pre>
    </div>
  );
}
const logError = (error, info) => {
  // Do something with the error, e.g. log to an external API
  if(error) console.log(error);
  if(info) console.log(info)
};

const ErrorHandler = ({ children }) => {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
        {children}
      </ErrorBoundary>
    </>
  );
};

export default ErrorHandler;
